import { driverAttributes } from '../../driver/queryAttributes';
import { vehicleAttributes } from '../../vehicle/queriesAttributes';

const coordinateAttributes = `
    latitude
    longitude
`;

export const pointsAttributes = `
    latitude
    longitude
`;

const timeWindowAttributes = `
    earliest
    latest
`;

const breakAttributes = `
    start_time
    end_time
    duration
`;

const destinationAttributes = `
    coordinate {
        ${coordinateAttributes}
    }
    city
    country
    neighborhood
    postal_code
    state
    street_address
    street_complement
    street_number
`;

const proofOfConclusionAttributes = `
    id
    user_id
    fleet_id
    client
    img_urls
    saved_at
    completed_at
    user_name
    address
    observation
    activity_id
    vehicle_id
    model
    license_plate
`;

export const activityAttributes = ({ withPOC }: { withPOC: boolean }) => `
    id
    name
    type
    visit_status
    completion_status
    position
    destination {
      ${destinationAttributes}
    }
    time_windows {
      ${timeWindowAttributes}
    }
    route_name
    waiting_time
    created_at
    updated_at
    planned_duration
    planned_distance_in_meters
    start_time
    end_time
    additional_info
    route_id
    driver_id
    driver_name
    device_id
    vehicle_id
    arrival_time
    executed_duration
    ${
      withPOC
        ? `proof_of_conclusion {
      ${proofOfConclusionAttributes}
    }`
        : ''
    }
    executed_end_time
    phone_number
    load_size
`;

const routeWorkingHoursAttributes = `
    start_time
    end_time
`;

export const routeSettingsAttributes = `
    routing_type
    objectives
    break_window {
      ${breakAttributes}
    }
    working_hours {
      ${routeWorkingHoursAttributes}
    }
    vehicle_average_cargo_capacity
`;

export const routeRecurrencyAttributes = `
    id
    repeat_interval
    frequency
    days_of_month
    week_numbers
    days_of_week
    until_date
`;

export const routeAttributes = ({ withPoints, withPOC }: { withPoints: boolean; withPOC: boolean }) => `
    id
    name
    activities {
      ${activityAttributes({ withPOC })}
    }
    ${
      withPoints
        ? `points {
            ${pointsAttributes}
          }`
        : ''
    }
    type
    status
    planned_duration
    planned_distance_in_meters
    start_time
    executed_start_time
    end_time
    executed_end_time
    created_at
    updated_at
    vehicle_id
    driver_id
    device_id
    shared_id
    driver_name
    break {
      ${breakAttributes}
    }
    settings {
      ${routeSettingsAttributes}
    }
    recurrency {
      ${routeRecurrencyAttributes}
    }
    propagation_type
`;

const inputDestinationAttributes = `
    coordinate {
        ${coordinateAttributes}
    }
    city
    country
    neighborhood
    postal_code
    state
    street_address
    street_complement
    street_number
`;

const spreadsheetActivity = `
    destination {
        ${inputDestinationAttributes}
    }
    duration
    load_size
    start_date
    start_hour
    name
    time_windows {
        ${timeWindowAttributes}
    }
    additional_info
    phone_number
`;

export const spreadsheetImportResultAddressAttributes = `
  query_address
  activity{${spreadsheetActivity}}
  warnings {
    field
    raw_value
  }
`;

export const pagedRoutesAttributes = ({ withPoints, withPOC }: { withPoints: boolean; withPOC: boolean }) => `
    content {
        ${routeAttributes({ withPoints, withPOC })}
    }
    last
    total_pages
    total_elements
    number_of_elements
    number
    size
    first
    empty
`;

const plannedVsExecutedAttributes = `
    planned
    executed
`;

const reportActivityAttributes = ({ withObservations }: { withObservations: boolean }) => `
    id
    type
    completion_status
    name
    instructions
    ${withObservations ? 'observations' : ''}
    time_windows {
        ${timeWindowAttributes}
    }
    destination {
        ${destinationAttributes}
    }
    start_time {
        ${plannedVsExecutedAttributes}
    }
    end_time {
        ${plannedVsExecutedAttributes}
    }
    duration {
        ${plannedVsExecutedAttributes}
    }
    phone_number
    driver {
        ${driverAttributes}
    }
    vehicle {
        ${vehicleAttributes}
    }
`;

export const routeReportAttributes = ({ withObservations, withExecutedDistance }: { withObservations: boolean; withExecutedDistance: boolean }) => `
    id
    status
    activities {
        ${reportActivityAttributes({ withObservations })}
    }
    distance {
        planned
        ${withExecutedDistance ? 'executed' : ''}
    }
    start_time {
        ${plannedVsExecutedAttributes}
    }
    end_time {
        ${plannedVsExecutedAttributes}
    }
    duration {
        ${plannedVsExecutedAttributes}
    }
    name
    driver {
        ${driverAttributes}
    }
    vehicle {
        ${vehicleAttributes}
    }
`;

const executionDigestSummaryAttributes = `
  total
  ids
`;

export const activitiesSummaryAttributes = `
  total
  completed {
    ${executionDigestSummaryAttributes}
  }
  not_completed {
    ${executionDigestSummaryAttributes}
  }
  waiting {
    ${executionDigestSummaryAttributes}
  }
`;

const routesSummaryAttributes = `
  total
  routes_with_vehicle {
    ${executionDigestSummaryAttributes}
  }
  routes_without_vehicle {
    ${executionDigestSummaryAttributes}
  }
`;

export const operationSummaryAttributes = `
  activities {
    ${activitiesSummaryAttributes}
  }
  routes {
    ${routesSummaryAttributes}
  }
`;

export const pagedActivitiesAttributes = ({ withPOC }: { withPOC: boolean }) => `
    content {
        ${activityAttributes({ withPOC })}
    }
    last
    total_pages
    total_elements
    number_of_elements
    number
    size
    first
    empty
`;
